import { Rectangle, removeOverlaps } from "webcola";

export const overlapRemoval = (cyto) => {
  const nodes = cyto.nodes().jsons();
  let flag_compound = false;

  for (let i = 0; i < nodes.length; i++) {
    if ("parent" in nodes[i].data) {
      flag_compound = true;
      break;
    }
  }

  if (flag_compound) {
    overlapRemovalCompoundNetwork(cyto);
  } else {
    overlapRemovalSimpleNetwork(cyto);
  }

  cyto.fit(50);
};

const getRectangles = (cyto, nodes) => {
  return nodes.map((node) => {
    let bbox = cyto.$(`#${node.data.id}`).boundingBox({
      includeNodes: true,
      includeEdges: false,
      includeLabels: true,
      includeMainLabels: true,
      includeSourceLabels: false,
      includeTargetLabels: false,
      includeOverlays: false,
    });

    return new Rectangle(
      Math.ceil(bbox.x1),
      Math.ceil(bbox.x2),
      Math.ceil(bbox.y1),
      Math.ceil(bbox.y2)
    );
  });
};

const overlapRemovalCompoundNetwork = (cyto) => {
  const nodes = cyto.nodes().jsons();
  const graph = createGraph(nodes);
  const order = bfs(graph);
  const mapped_compound_nodes = nodesByCompounds(nodes);
  networkOverlapRemoval(cyto, order, mapped_compound_nodes);
};

const nodesByCompounds = (nodes) => {
  const map_parent_nodes = { universe: [] };

  for (let i = 0; i < nodes.length; i++) {
    if ("parent" in nodes[i].data) {
      let par = nodes[i].data.parent;
      if (!(par in map_parent_nodes)) {
        map_parent_nodes[par] = [];
      }
      map_parent_nodes[par].push(nodes[i]);
    } else {
      map_parent_nodes["universe"].push(nodes[i]);
    }
  }

  return map_parent_nodes;
};

const networkOverlapRemoval = (cyto, order, mapped_compound_nodes) => {
  for (let cmp = 0; cmp < order.length; cmp++) {
    let compound_nodes = mapped_compound_nodes[order[cmp]];
    singleOverlapRemoval(cyto, compound_nodes);
  }
};

const singleOverlapRemoval = (cyto, nodes) => {
  const rects = getRectangles(cyto, nodes);

  removeOverlaps(rects);
  removeOverlaps(rects);

  nodes.forEach((node, index) => {
    cyto.$(`#${node.data.id}`).position({
      x: rects[index].cx(),
      y: rects[index].cy(),
    });
  });
};

const overlapRemovalSimpleNetwork = (cyto) => {
  const nodes = cyto.nodes().jsons();
  const rects = getRectangles(cyto, nodes);

  removeOverlaps(rects);
  removeOverlaps(rects);

  nodes.forEach((node, index) => {
    cyto
      .$(`#${node.data.id}`)
      .position({ x: rects[index].cx(), y: rects[index].cy() });
  });
};

const createGraph = (nodes) => {
  let graph = {};
  nodes.forEach((node) => {
    if (
      node.data.node_type === "compartment" ||
      node.data.node_type === "powernode"
    ) {
      const par = "parent" in node.data ? node.data.parent : "universe";
      if (!(par in graph)) {
        graph[par] = [];
      }

      if (!(node.data.id in graph)) {
        graph[node.data.id] = [];
      }

      graph[par].push(node.data.id);
    }
  });
  return graph;
};

const bfs = (graph) => {
  let visited = [];
  let queue = [];
  let results = [];

  const breadthFirstSearch = (visited, graph, node) => {
    visited.push(node);
    queue.push(node);

    while (queue.length > 0) {
      // Remove element of index 0.
      const s = queue[0];
      results.push(s);
      queue.splice(0, 1); // 2nd parameter means remove one item only

      graph[s].forEach((neighbour) => {
        if (!visited.includes(neighbour)) {
          visited.push(neighbour);
          queue.push(neighbour);
        }
      });
    }
  };

  breadthFirstSearch(visited, graph, "universe");

  const order = results.reverse();
  return order;
};
